import { LayoutObject } from '../../types/types';

export const getLayoutObjectParam = (
  object: LayoutObject,
  name: string
): unknown => {
  if (object[name] !== undefined) {
    return object[name];
  }

  const lowerName = name.toLowerCase();
  const key = Object.keys(object).find(
    (objectKey) => objectKey.toLowerCase() === lowerName
  );

  return key === undefined ? undefined : object[key];
};
